import { Component, OnInit } from '@angular/core';
import { WorkflowActionHistoryComponent } from '@dsvs/workflow-generator-ui-lib';

@Component({
  selector: 'fes-fes-workflow-action-deliverydate-history',
  templateUrl: './fes-workflow-action-deliverydate-history.component.html',
  styleUrls: ['./fes-workflow-action-deliverydate-history.component.scss']
})
export class FesWorkflowActionDeliverydateHistoryComponent extends WorkflowActionHistoryComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
